// Tên các thẻ của hộp hướng dẫn trang Cơ chế lương — MỘT nguồn.
//
// Tách khỏi `SalaryGuideDialog.tsx` vì hai bên khác đều cần: bài văn trong kho
// nội dung bảo người đọc 'mở thẻ "…"' bằng đúng những chữ này, và bài kiểm
// đối chiếu hai bên. Gõ tên ở hai nơi thì đổi một nơi là hướng dẫn chỉ tới một
// thẻ không tồn tại — im lặng, vì chữ trong bài chỉ là chuỗi.

/** Id trang dùng hộp riêng này. Tra bằng hằng số, không gõ chuỗi lần hai. */
export const SALARY_GUIDE_ID = "salary_rules_v2";

export const SALARY_GUIDE_TABS = {
  flow: "Tiền ra từ đâu",
  where: "Trên màn có gì",
  how: "Cách trang chạy",
  work: "Việc của bạn",
  status: "Trạng thái",
} as const;
